import { SiteFormValidationSchema } from '../../../sites.interfaces';

export const sitesFormValidationSchema: SiteFormValidationSchema = {
  name: [
    { required: true, message: 'Введіть назву сайту' },
    { type: 'string', message: 'Назва має бути строкою' },
    { min: 3, max: 100, message: 'Назва має бути довжиною не менше 3 символів та не більше 100' }
  ]
};
